import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MCommis';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';


import React from 'react';
import { Checkbox, Col, Row } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import CheckboxF from "../../ChexBox";
import CheckStan from "../../Prints/CheckStan";
import { Label } from "@mui/icons-material";

//pour le CATEGORIE client
let searchCtegoCli: ParamsPicklist = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }

//pour le CATEGORIE CPT
let searchCtegoCpt: ParamsPicklist = { CodeAgence: '', Table: "CATEGOCPT", Colonne1: "codcat", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }

//pour le Plancp
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

// pour les commissions
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne2: "CODOPE", Colonne1: "LIBELL", Colagence: '101', Choix: 11, Init: '94' }

// Type de Type cpt
let searchTypCPT: ParamsPicklist = { CodeAgence: '', Table: "TYPECPT", Colonne2: "CODTYP", Colonne1: "LIBELLE", Colagence: '101', Choix: 11, Init: '94' }

// Type de Frequence cpt
let searchTypFre: ParamsPicklist = { CodeAgence: 'PERIOD', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

// Type de sens solde
let searchTypSens: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

//pour le compte de groupe
let searchcptgrp: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }

//pour le compte de groupe
let searchGRILLECOMMISSION: ParamsPicklist = { CodeAgence: '', Table: "GRILLECOMMISSION", Colonne1: "CODGRILLE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }





const Commis = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")

    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    const dataOption2: DataSelect[] = [
        { label: "01-Inter?t d?biteur", value: "01-Inter?t d?biteur" },
        { label: "02-Inter?t cr?diteur", value: "02-Inter?t cr?diteur" },
        { label: "03-Commission", value: "03-Commission" }
    ]


    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        consult();
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('')
    }

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Interêt et Commission
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >

 <fieldset className="bordure1" style={{
    marginTop: 10,
    padding: '15px 20px',
    border: '1px solid #ccc',
    borderRadius: 8,
  }}>
 

  <Box style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
     <legend
    style={{
        marginTop: "-8px", // <-- remonte le legend
      //padding: '0 10px',
      //fontSize: '1rem',
     // fontWeight: 500,
     // lineHeight: 'normal',
     maxWidth: 'auto',
    }}
  >
    Mise en place d'un Intérêt ou d'une Commission
  </legend>
    {/* -------- Colonne 1 -------- */}
    <Box style={{ flex: 1, minWidth: 280, display: "flex", flexDirection: "column", gap: 1 }}>
      <SearInputG
        width={12}
        dissabledCode={false}
        notremove
        Titre="Recherche"
        label="Code commission"
        name="CODCOM"
        Taille1="100%"
        Taille2={0}
        Parametre={searchPlancp}
        form={form}
      />
      <Form.Item style={{ width: "100%" }}>
        <SelectOption
          Option={dataOption2}
          width={0}
          label="Catégorie"
          Size="100%"
          name="categorie"
        />
      </Form.Item>
      <InputForm width={12} label="Montant" type="number" name="MTMINI" />
      <InputForm width={12} label="Taux débit" type="number" money name="TXDEBI" />
      <InputForm width={12} label="Solde minimum " type="number" name="soldMin" />
      <InputForm width={12} label="Solde maximun" type="number" name="soldMax" />
      <InputForm width={12} label="Solde moyen" type="number" name="SOLMOY" />
      
    </Box>

    {/* -------- Colonne 2 -------- */}
    <Box style={{ flex: 1, minWidth: 280, display: "flex", flexDirection: "column", gap: 1 }}>
      <InputForm width={12} label="Libellé" type="texte" name="LIBELL" />

      <SearchModal
        width={12}
        Titre=""
        defaultCode="0"
        label="Id compte produit"
        name="IdNUMCPT"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />

      <SearchModal
        width={12}
        Titre=""
        defaultCode="0"
        label="Id compte agios à recevoir"
        name="Idcptimp"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />

      <SearchModal
        width={12}
        Titre=""
        defaultCode="0"
        label="Id compte TVA à recevoir"
        name="Idcpttvaimp"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />

      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Code plage TVA"
        name="CDPLAG"
        Taille1="100%"
        Parametre={searchGRILLECOMMISSION}
        Taille2="100%"
        form={form}
      />

      <InputForm defaultValue="0" notRequired width={12} label="Taux TVA collectée" type="number" money name="TXTAXE" />
      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Id compte TVA collectée"
        name="IdCptTva"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />
    </Box>

    {/* -------- Colonne 3 -------- */}
    <Box style={{ flex: 1, minWidth: 280, display: "flex", flexDirection: "column", gap: 1 }}>
      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Id compte frais gestion"
        name="IdCptFrais"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />
      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Code plage frais gestion"
        name="cdplagfraiges"
        Taille1="100%"
        Parametre={searchGRILLECOMMISSION}
        Taille2="100%"
        form={form}
      />
      <InputForm
        defaultValue="0"
        notRequired
        width={12}
        label="Montant frais gestion"
        type="number"
        name="MONFRA"
      />
      <InputForm
        defaultValue="0"
        notRequired
        width={12}
        label="Minimum autorisé frais gestion"
        type="number"
        name="minifraig"
      />

      <InputForm defaultValue="0" notRequired width={12} label="Taux TPRCM" type="number" money name="TXTPRC" />
      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Id compte TPRCM"
        name="IdCptTprcm"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />

      <InputForm
        notRequired
        defaultValue="0"
        width={12}
        label="Taux Dépassement TPRCM"
        type="number"
        money
        name="TXDECOUV"
      />
      <SearchModal
        notRequired
        defaultCode="0"
        width={12}
        Titre=""
        label="Id compte Dépassement TPRCM"
        name="IdCPTDECOUV"
        Taille1="100%"
        Parametre={searchTypSens}
        Taille2="100%"
        form={form}
      />
    </Box>
  </Box>
</fieldset>


                        </Box>
                    </div>
                </div >
            </>,
        }
    ];


    // // consult 
    // function Consult() {

    //     if (form.getFieldValue('AAA') == 'okokokok') {
    //         alert('vrai')
    //     } else {
    //         alert('faux')
    //     }

    // }

    // function consult 
    function consult() {
        if (form.getFieldValue("CODCOM") == null) {
            SweetAlert.fire({ title: "Svp renseigner le code commission", icon: "warning" });
        } else {
            let data = (form.getFieldValue("CODCOM"));

            if (data.length != 0) {
                setLoading(true)

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadCommis,
                    headers: {
                        'CypherCodcom': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            //console.log(DemandVP);

                            if (res.StatutCode == 200) {

                                form.setFieldsValue(DemandVP);

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
        form.resetFields()
        localStorage.clear()
    }


    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: Demand = values

        Demand.DATCRE = formatDate(Perss.datjour)
        Demand.DATMOD = formatDate(Perss.datjour)
        Demand.codage = Perss.codage
        Demand.UTILIS = Perss.coduti

        let aaa = ''

        if (form.getFieldValue("categorie") == '01-Inter?t d?biteur' || form.getFieldValue("categorie") == '02-Inter?t cr?diteur') {
            aaa = 'interêt';
        } else {
            aaa = 'Commission';
        }

        if (sbmit == "add") {

            SweetAlert.fire({
                title: "Création d'un(e) " + aaa,
                text: "Voulez-vous Créer cette " + aaa,
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateCommis,
                        headers: {
                            'CypherCommis': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result

                                console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {

                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })

                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        //HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }

        if (sbmit == "modif") {



            SweetAlert.fire({
                title: "M.A.J d'un(e)" + aaa,
                text: "Voulez-vous mettre a jour cet " + aaa,
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateCommis,
                        headers: {
                            'CypherCommis': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    setIsSubmit(false)
                                    HandleAnnul()
                                    SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }

        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "suppression " + aaa,
                text: "Voulez-vous supprimer cet " + aaa,
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.CODCOM));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.deletePlanCp,
                        headers: {
                            'CypherCodcom': Demand.CODCOM,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    if (res.Message == "Erreur") {
                                        SweetAlert.fire({ title: "Svp préciser le type de modification", icon: "warning" })
                                        //HandleAnnul()
                                    } else {
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: "Suppression Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }


    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };


    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { HandleConsult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}

export default Commis;